import wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/projects/shapoorjiWildernest.webp";
import s from "../../../../public/projects/ShapoorjiPaloonji/images/logo/s.png";
import vanaha from "../../../../public/projects/ShapoorjiPaloonji/images/projects/vanaha.webp"

// ShapoorjiPaloonji golfland
import overviewImage_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Overview/1.webp";
import bannerDesktopImage_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Banner/1.webp";
import bannerMobileImage_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Banner/2.webp";
import siteVisitBannerImage_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/SiteVisitBanner/1.webp";
import Location_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Location/L1.webp";
import Hightlights_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Highlights/1.webp";
import floorplan1_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/floorplan/1.webp";
import floorplan2_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/floorplan/2.webp";
import floorplan3_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/floorplan/3.webp";
import floorplan4_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/floorplan/4.webp";
// import floorplan5_golfland         from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/floorplan/5.webp";
import locationicon_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Overview/l.png";
import calicon_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Overview/c.png";
import newlaunchicon_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Overview/n.png";
import gallery1_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Gallery/1.webp";
import gallery2_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Gallery/2.webp";
import gallery3_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Gallery/3.webp";
import gallery4_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Gallery/4.webp";
import gallery5_golfland from "../../../../public/projects/ShapoorjiPaloonji/images/golfland/Gallery/5.webp";

// ShapoorjiPaloonji wildernest 
import overviewImage_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Overview/1.webp";
import bannerDesktopImage_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Banner/1.webp";
import bannerMobileImage_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Banner/2.webp";
import siteVisitBannerImage_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/SiteVisitBanner/1.webp";
import Location_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Location/L1.webp";
import Hightlights_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Highlights/1.webp";
import floorplan1_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/floorplan/1.webp";
import floorplan2_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/floorplan/2.webp";
import floorplan3_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/floorplan/3.webp";
// import floorplan4_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/floorplan/4.webp";
// import floorplan5_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/floorplan/5.webp";
import locationicon_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Overview/l.png";
import calicon_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Overview/c.png";
import newlaunchicon_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Overview/n.png";
// import loc from "./images/Overview/loc.png"
import gallery1_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Gallery/1.webp";
import gallery2_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Gallery/2.webp";
import gallery3_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Gallery/3.webp";
import gallery4_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Gallery/4.webp";
import gallery5_wildernest from "../../../../public/projects/ShapoorjiPaloonji/images/wildernest/Gallery/5.webp";

// joyvillesensorium
import overviewImagejoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/overview/1.webp";
import bannerDesktopImagejoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/banner/1.webp";
import bannerMobileImagejoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/banner/2.webp";
import Locationjoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/location/1.webp";
import Hightlightsjoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/highlights/1.webp";
import floorplan1joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/floorplan/1.webp";
import floorplan2joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/floorplan/2.webp";
import floorplan3joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/floorplan/3.webp";
import floorplan4joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/floorplan/4.webp";
import floorplan5joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/floorplan/5.webp";
import locationiconjoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/overview/l.png";
import caliconjoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/overview/c.png";
import newlaunchiconjoyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/overview/n.png";
import gallery1joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/gallery/1.webp";
import gallery2joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/gallery/2.webp";
import gallery3joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/gallery/3.webp";
import gallery4joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/gallery/4.webp";
import gallery5joyvillesensorium from "../../../../public/projects/ShapoorjiPaloonji/images/joyvillesensorium/gallery/5.webp";

// dualis
import overviewImagedualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/overview/1.webp";
import bannerDesktopImagedualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/banner/1.webp";
import bannerMobileImagedualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/banner/2.webp";
import Locationdualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/location/1.webp";
import Hightlightsdualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/highlights/1.webp";
import floorplan1dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/floorplan/1.webp";
import floorplan2dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/floorplan/2.webp";
import floorplan3dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/floorplan/3.webp";
import floorplan4dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/floorplan/4.webp";
import floorplan5dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/floorplan/5.webp";
import locationicondualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/overview/l.png";
import calicondualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/overview/c.png";
import newlaunchicondualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/overview/n.png";
import gallery1dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/gallery/1.webp";
import gallery2dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/gallery/2.webp";
import gallery3dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/gallery/3.webp";
import gallery4dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/gallery/4.webp";
import gallery5dualis from "../../../../public/projects/ShapoorjiPaloonji/images/dualis/gallery/5.webp";



export const developersShapoorji = {
  name: `Shapoorji Pallonji Properties in Pune`,
  properties: [
    {
      name: " Shapoorji Pallonji  Wildernest ",
      image: wildernest,
      price: "On Request",
      developer: "Shapoorji Pallonji",
      state: "Pune",
      location: "Shewalewadi, Pune",
      projectlocation: "East Pune",
      bed: "3 - 4 BHK",
      size: "1500 - 1800 sq. ft.",
      url: `/wildernest-sp-kingston-shewalewadi-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Shapoorji Pallonji Golfland",
      image: vanaha,
      price: "On Request",
      developer: "Shapoorji Pallonji",
      state: "Pune",
      location: "Vanaha, Pune",
      projectlocation: "West Pune",
      bed: "1 - 4 BHK ",
      size: "739 - 2995 sq. ft..",
      url: `/shapoorji-pallonji-vanaha-bavdhan-pune`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Shapoorji Joyville Sensorium",
      image: bannerDesktopImagejoyvillesensorium,
      price: " 1.65 Crore Onwards",
      developer: "Shapoorji Pallonji",
      state: "Pune",
      location: "Hinjewadi, Pune",
      projectlocation: "East Pune",
      bed: "2 - 3 BHK ",
      size: "702 - 979 sq. ft.",
      url: `/shapoorji-joyville-sensorium`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "M3M Altitude", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
    {
      name: "Shapoorji Pallonji The Dualis",
      image: bannerDesktopImagedualis,
      price: "  7 Crore Onwards",
      developer: "Shapoorji Pallonji",
      state: "Gurugram",
      location: "Sector 46, Gurgaon",
      projectlocation: "Gurugram",
      bed: "2 - 3 BHK ",
      size: "2800 - 3600 sq.ft.",
      url: `/shapoorji-pallonji-dualis`,
      form: {
        source_id: 11,
        api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
        api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
        sub_source_id: 130,
        builder_id: `103`,
        project_id: `477`,
        subject: "Shapoorji Pallonji The Dualis", // Add or update the subject here
        to_email: "jatin.rohilla@propertystation.in",
      }
    },
  ],
};

export const Headers = {
  logo: s,
  data: {
    experience: "1865",
  },
  about: `Shapoorji Pallonji And Company Private Limited is a global, 
  diversified organisation of 15 major companies. We deliver end-to-end
   solutions in 6 business segments, including Engineering &
    Construction, Infrastructure, Real Estate, Water, Energy and 
    Financial Services. Our dedicated workforce of over 35,000 people
     in over 40 countries is focused on sustainable development while
      developing megastructures and iconic landmarks. `,
};

export const projectsshapoorji = {
  golfland: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_golfland,
      bannerMobileImage: bannerMobileImage_golfland,
      textOverlay: "",
      data: {
        title: "Shapoorji Pallonji Golfland",
        subtitle: "Vanaha, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100028033",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at  Shapoorji Pallonji Golfland",
      description: [
        "The Vanaha Township by Shapoorji Pallonji in Bavdhan, Pune, is one of India's largest ITP-approved integrated townships, spread across an expansive 1000 acres. Designed for elegance and comfort, each apartment features stylish architecture and premium amenities, offering a serene retreat for families. More than just a residence, Vanaha is built on the CCH philosophy, fostering holistic child development through nine celebrity-led learning academies. ",
        " With a perfect blend of modern infrastructure, lush green surroundings, and thoughtfully curated experiences, this township redefines community living, ensuring a balanced and enriching lifestyle for residents of all ages.",
      ],
      image: overviewImage_golfland,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_golfland,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_golfland,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_golfland,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_golfland,
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "1 BHK ",
          area: "739 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "2 BHK Duplex ",
          area: "1011 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK + Study ",
          area: "1490 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK + Study ",
          area: "2340 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK Duplex ",
          area: "2955 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },

      ],
    },

    floor_plan: [
      {
        type: "1 BHK ",
        area: "739 sq. ft.",
        price: "On Request*",
        image: floorplan1_golfland,
      },
      {
        type: "2 BHK Duplex ",
        area: "1011 sq. ft.",
        price: "On Request*",
        image: floorplan2_golfland,
      },
      {
        type: "3 BHK + Study ",
        area: "1490 sq. ft.",
        price: "On Request*",
        image: floorplan3_golfland,
      },
      {
        type: "4 BHK + Study ",
        area: "2340 sq. ft.",
        price: "On Request*",
        image: floorplan4_golfland,
      },
      {
        type: "4 BHK Duplex ",
        area: "2955 sq. ft.",
        price: "On Request*",
        image: floorplan4_golfland,
      },

    ],

    highlights: {
      images: Hightlights_golfland,
      tagline: "Highlights",
      features: [
        "Easy connectivity to major IT Hubs in Pune.",
        "Oxford Golf Resort.",
        "350+ acres of open Space in the township.",
        "Over 400 species of Flora and Fauna .",
        "Largest reserved green of 90 acres.",
      ],
    },

    location: {
      image: Location_golfland,
      data: [
        {
          airport: {
            distance_time: "28 km",
            name: "Pune Airport"
          },
          school: {
            distance_time: "6 Km",
            name: "M P School"
          },
          railwayormetro: {
            distance_time: "20 Km",
            name: "Dapodi Station"
          },
          hospital: {
            distance_time: "7 Km",
            name: "Shatayu Hospital"
          },
          mall: {
            distance_time: "14 Km",
            name: "Westend Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_golfland },
        { image: gallery2_golfland },
        { image: gallery3_golfland },
        { image: gallery4_golfland },
        { image: gallery5_golfland },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in  Shapoorji Pallonji Golfland, kindly share more details.",
    },

    faq: [
      {
        question: "What is Shapoorji Pallonji Golfland Vanaha?",
        answer: `Shapoorji Pallonji Golfland Vanaha is a premium residential project located in Bavdhan, Pune. It offers luxury apartments with a golf-themed lifestyle and world-class amenities.`,
      },
      {
        question: "Where is Golfland Vanaha located?",
        answer: `The project is located in Bavdhan, Pune, near the Oxford Golf Resort, offering a serene and green environment with excellent connectivity.`,
      },
      {
        question: "What types of apartments are available in Golfland Vanaha?",
        answer: `The project offers 1 BHK, 2 BHK, and 3 BHK luxury apartments with modern designs and spacious layouts.`,
      },
      {
        question: "What are the key amenities offered in Shapoorji Pallonji Golfland Vanaha?",
        answer: `The project features a golf course, clubhouse, swimming pool, gym, jogging tracks, landscaped gardens, kids’ play area, and 24/7 security.`,
      },
      {
        question: "Who is the developer of Golfland Vanaha?",
        answer: `The project is developed by Shapoorji Pallonji Real Estate, a reputed real estate brand known for high-quality developments.`,
      },
      {
        question: "Is Golfland Vanaha RERA registered?",
        answer: `Yes, the project is RERA registered, ensuring transparency and legal compliance.`,
      },
      {
        question: "Where is Golfland Vanaha located?",
        answer: `The project is located in Bavdhan, Pune, near the Oxford Golf Resort, offering a serene and green environment with excellent connectivity.`,
      },
      {
        question: "What is the total area of the project?",
        answer: `The project is spread over a vast expanse within the Vanaha Township, offering a premium and spacious lifestyle.`,
      },
      {
        question: "What makes Shapoorji Pallonji Golfland Vanaha a standout choice for homebuyers?",
        answer: `Golfland Vanaha stands out as a premium residential choice for homebuyers due to its breathtaking surroundings, luxury living, and world-class amenities.`,
      },
      {
        question: "What makes Golfland Vanaha unique?",
        answer: `Its unique feature is the golf-course living experience, combined with lush greenery, modern amenities, and proximity to Pune’s key locations.`,
      },
    ],

    similar: {
      properties: [
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },

  },
  wildernest: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImage_wildernest,
      bannerMobileImage: bannerMobileImage_wildernest,
      textOverlay: "",
      data: {
        title: "Shapoorji Pallonji wildernest",
        subtitle: "Hadapsar, Pune",
        starting_price: "On Request",
        payment_plan: "CLP",
        rerano: "P52100052683",
        status: "Under Construction"
      }
    },
    overview: {
      heading: "Discover Luxury Living at Shapoorji Pallonji wildernest ",
      description: [
        "Welcome to Wildernest, where life flows as effortlessly as the silver streams weaving through this luxurious retreat. Here, towering high-rises give way to lush greenery, and architecture harmonizes with nature. Yet, city conveniences are never far—just 10 minutes from Magarpatta IT Park, Wildernest offers seamless connectivity to key infrastructure and commercial hubs. This serene escape by Shapoorji Pallonji perfectly balances urban convenience with natural tranquility. ",
        " At its core, the CCH philosophy fosters holistic child development through nine celebrity-led learning academies, ensuring a nurturing environment for young minds. Experience the best of both worlds at Wildernest.",
      ],
      image: overviewImage_wildernest,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicon_wildernest,
          title: "On Request ",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicon_wildernest,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicon_wildernest,
          title: "Under Construction",
          subtitle: "Status",
        },
      ],
    },

    sitevisit: {
      image: siteVisitBannerImage_wildernest,
    },
    floor_plan: [
      {
        type: "3 BHK ",
        area: "1500 sq. ft.",
        price: "On Request*",
        image: floorplan1_wildernest,
      },
      {
        type: "4 BHK ",
        area: "1900 sq. ft.",
        price: "On Request*",
        image: floorplan3_wildernest,
      },
      {
        type: "Villa-1 ",
        area: "2400 sq. ft.",
        price: "On Request*",
        image: floorplan2_wildernest,
      },
      {
        type: "Villa-2 ",
        area: "2800 sq. ft.",
        price: "On Request*",
        image: floorplan2_wildernest,
      },


    ],
    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK ",
          area: "1500 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "4 BHK ",
          area: "1900 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "Villa-1 ",
          area: "2400 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },
        {
          type: "Villa-2 ",
          area: "2800 sq. ft.",
          price: "On Request*",
          eoiAmount: "On Request",
        },

      ],


    },
    highlights: {
      images: Hightlights_wildernest,
      tagline: "Highlights",
      features: [
        "Low Density Project.",
        "Only 34 unique families in 1 acre.",
        "30000 Sqft Grand Club House .",
        "Uncity Living within the city.",
        "Unique: Only 377 families in 11 Acres of development.",
      ],
    },

    location: {
      image: Location_wildernest,
      data: [
        {
          airport: {
            distance_time: "17 km",
            name: "Pune Airport"
          },
          school: {
            distance_time: "1 Km",
            name: "P T School"
          },
          railwayormetro: {
            distance_time: "9 Km",
            name: "Hadapsar Station"
          },
          hospital: {
            distance_time: "1 Km",
            name: "Y M Hospital"
          },
          mall: {
            distance_time: "8 Km",
            name: "Amanora Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1_wildernest },
        { image: gallery2_wildernest },
        { image: gallery3_wildernest },
        { image: gallery4_wildernest },
        { image: gallery5_wildernest },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Shapoorji Pallonji wildernest , kindly share more details.",
    },

    faq: [

      {
        question: "Where is Wildernest  situated?",
        answer: `The project is located in Shewalewadi, Hadapsar Annexe, along the Pune-Solapur Highway. It is conveniently positioned near key areas such as Magarpatta IT Park, EON IT Park, and the World Trade Centre.`,
      },
      {
        question: "What are the available configurations of the residences?",
        answer: `Wildernest offers spacious 3 BHK with sizes ranging from 1500 sq. ft. and 4 BHK with sizes range of 1900 sq.ft.. `,
      },
      {
        question: "What is the starting price for these residences?",
        answer: `The 3 BHK and 4 BHK apartments start at ₹1.69 Crores. The exclusive Mango Villas and Villaments start at ₹5 Crores.`,
      },
      {
        question: "What amenities are offered at Wildernest Project?",
        answer: `The project boasts a range of amenities, including a best-in-class clubhouse, kids' play area, outdoor working pods, and is surrounded by over 150 mango trees. The design emphasizes nature-inspired architecture with approximately 75% open spaces.`,
      },
      {
        question: "Is the project RERA registered?",
        answer: `Yes, Wildernest Shewalewadi is RERA registered. The registration number for Mango Tree Villa Tower 1 is P52100052683.`,
      },
      {
        question: "What makes Shapoorji Pallonji Wildernest a standout choice for homebuyers?",
        answer: `Shapoorji Pallonji Wildernest stands out as a premier choice for homebuyers due to its serene natural surroundings, thoughtfully designed residences, and top-tier amenities.`,
      },
      {
        question: "What is the expected possession date?",
        answer: `The project is currently under construction, with an expected completion date by June 2027.`,
      },
      {
        question: "How is the connectivity to major hubs in Pune?",
        answer: `Wildernest offers excellent connectivity. It's 6 km from Magarpatta IT Park, 10.9 km from EON IT Park and the World Trade Centre, and 12.5 km from Pune Railway Station. The Pune Airport is approximately 12.2 km away.`,
      },
      {
        question: "Are there educational institutions nearby?",
        answer: `Yes, there are several prominent schools within an 8 km radius, making it convenient for families with children.`,
      },
      {
        question: "What healthcare facilities are in the vicinity?",
        answer: `Reputed hospitals are available within an 8 km radius, ensuring residents have access to quality healthcare services`,
      },
    ],

    similar: {
      properties: [

        {
          name: "Shapoorji Pallonji Vanaha",
          image: vanaha,
          price: "On Request",
          developer: "Shapoorji",
          state: "Pune",
          location: "Pune",
          projectlocation: "West Pune",
          bed: "1 - 4 BHK ",
          size: "....",
          url: `/shapoorji-pallonji-vanaha-bavdhan-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  joyvillesensorium: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagejoyvillesensorium,
      bannerMobileImage: bannerMobileImagejoyvillesensorium,
      textOverlay: "",
      data: {
        title: "Shapoorji Joyville Sensorium",
        subtitle: "Hinjewadi, Pune",
        starting_price: "1.65 Crore Onwards",
        payment_plan: "CLP",
        rerano: "--",
        status: "Partially Ready To Move"
      }
    },
    overview: {
      heading: "Shapoorji Joyville Sensorium Hinjewadi, Pune ",
      description: [
        "Shapoorji Joyville Sensorium in Hinjewadi, Pune, is a premium residential development by the renowned Shapoorji Pallonji Group, designed to offer a harmonious blend of luxury, comfort, and sustainability. Located in the thriving IT hub of Hinjewadi Phase 1, the project is strategically positioned for seamless connectivity to major business centers, educational institutions, hospitals, and shopping destinations. The development features spacious 2 BHK and 3 BHK apartments, each crafted with modern layouts, premium fittings, and large balconies that provide stunning views and ample natural light. ",
        " Joyville Sensorium stands out for its extensive range of world-class amenities that cater to both relaxation and active lifestyles. Residents enjoy access to an infinity-edge swimming pool, a fully equipped gym, meditation pavilion, adventure trail, children’s play area, multipurpose hall, open-air gym, and beautifully landscaped gardens. The project also emphasizes community living with thoughtfully designed spaces for social interaction and recreation, including a clubhouse, BBQ area, and reflexology paths. Security is prioritized with advanced systems, ensuring peace of mind for all residents.",
        "Sustainability is a core focus at Joyville Sensorium, with eco-friendly features such as solar panels, rainwater harvesting, and energy-efficient appliances integrated throughout the development. The lush green surroundings and open spaces create a tranquil environment, offering a welcome retreat from the bustle of city life while remaining close to essential conveniences. As a RERA-approved project, Joyville Sensorium assures transparency and regulatory compliance, further enhancing its appeal for homebuyers and investors. With its combination of prime location, superior amenities, and the trusted legacy of Shapoorji Pallonji, Joyville Sensorium Hinjewadi represents a compelling opportunity for those seeking a modern, vibrant, and sustainable lifestyle in Pune.",
      ],
      keywordLinks: {

      },
      image: overviewImagejoyvillesensorium,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationiconjoyvillesensorium,
          title: "1.65 Cr ",
          subtitle: "Starting Price",
        },
        {
          iconClass: caliconjoyvillesensorium,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchiconjoyvillesensorium,
          title: "Partially Ready To Move",
          subtitle: "Status",
        },
      ],
    },
    floor_plan: [
      {
        type: "2 BHK ",
        area: "702-792 sq. ft.",
        price: "93.24 L - 1.05 Cr Onwards",
        image: floorplan1joyvillesensorium,
      },
      {
        type: "3 BHK ",
        area: "973-979 sq. ft.",
        price: " 1.31 - 1.32 Cr  Onwards",
        image: floorplan3joyvillesensorium,
      },


    ],
    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "2 BHK ",
          area: "702-792 sq. ft.",
          price: "93.24 L - 1.05 Cr Onwards",
          eoiAmount: "On Request",
        },
        {
          type: "3 BHK ",
          area: "973-979 sq. ft.",
          price: " 1.31 - 1.32 Cr  Onwards",
          eoiAmount: "On Request",
        },

      ],


    },
    highlights: {
      images: Hightlightsjoyvillesensorium,
      tagline: "Highlights",
      features: [
        "Clubhouse by the river featuring an infinity edge swimming pool.",
        "Charging station for electric vehicle.",
        "35 + world class amenities.",
        "International collaborators.",
      ],
    },

    location: {
      image: Locationjoyvillesensorium,
      data: [
        {
          airport: {
            distance_time: "23 km",
            name: "Pune Airport"
          },
          school: {
            distance_time: "- Km",
            name: "Delhi Public School (DPS), Hinjewadi"
          },
          railwayormetro: {
            distance_time: "- Km",
            name: "Pune Junction Railway Station"
          },
          hospital: {
            distance_time: "- Km",
            name: "Ruby Hall Clinic"
          },
          mall: {
            distance_time: "- Km",
            name: "Grand Highstreet Mall"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1joyvillesensorium },
        { image: gallery2joyvillesensorium },
        { image: gallery3joyvillesensorium },
        { image: gallery4joyvillesensorium },
        { image: gallery5joyvillesensorium },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Shapoorji Pallonji wildernest , kindly share more details.",
    },

    faq: [

      {
        question: "Where is Joyville Sensorium located?",
        answer: "Joyville Sensorium is situated in Hinjewadi Phase 1, Pune.",
      },
      {
        question: "What configurations are available at Joyville Sensorium?",
        answer: "Joyville Sensorium offers spacious 2 BHK and 3 BHK apartments.",
      },
      {
        question: "What amenities are offered at Joyville Sensorium?",
        answer: "The project offers a luxurious lifestyle with amenities such as a clubhouse with gymnasium and spa, and an infinity-edge swimming pool.",
      },
      {
        question: "Who is the developer of Joyville Sensorium?",
        answer: "Shapoorji Joyville Sensorium is developed by Shapoorji Pallonji Real Estate.",
      },
      {
        question: "What is the possession timeline for Joyville Sensorium?",
        answer: "Possession is expected within 2025, depending on the phase and tower booked.",
      },
      {
        question: "Is Joyville Sensorium RERA registered?",
        answer: "Yes, the project is RERA registered with registration number P52100026451.",
      },
      {
        question: "How is the connectivity from Joyville Sensorium?",
        answer: "The project offers excellent connectivity to Hinjewadi IT Park (5 mins), Mumbai-Pune Expressway (15 mins), and Baner (20 mins).",
      },
      {
        question: "Are there reputed schools and hospitals near Joyville Sensorium?",
        answer: "Yes, institutions like Indira National School and Symbiosis Centre for IT are nearby.",
      },
      {
        question: "What makes Joyville Sensorium unique?",
        answer: "Its nature-centric design with over 75% open spaces and a forest-themed landscape makes it a distinctive offering.",
      },
      {
        question: "How can I book a flat in Joyville Sensorium?",
        answer: "You can book a unit by contacting the sales team directly.",
      }
    ],

    similar: {
      properties: [

        {
          name: "Shapoorji Pallonji Vanaha",
          image: vanaha,
          price: "On Request",
          developer: "Shapoorji",
          state: "Pune",
          location: "Pune",
          projectlocation: "West Pune",
          bed: "1 - 4 BHK ",
          size: "....",
          url: `/shapoorji-pallonji-vanaha-bavdhan-pune`,
          form: {
            source_id: 11,
            api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
            api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
            sub_source_id: 130,
            builder_id: `103`,
            project_id: `477`,
            subject: "M3M Altitude", // Add or update the subject here
            to_email: "jatin.rohilla@propertystation.in",
          }
        },
      ],
    },
    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry", // Add or update the subject here
      to_email: "leads@gurugram-property.com",
    },
  },
  dualis: {
    bannerdata: {
      bannerDesktopImage: bannerDesktopImagedualis,
      bannerMobileImage: bannerMobileImagedualis,
      textOverlay: "",
      data: {
        title: "Shapoorji Pallonji The Dualis",
        subtitle: "Sector 46, Gurgaon",
        starting_price: "₹ 7 Crore Onwards",
        payment_plan: "CLP",
        rerano: "HRERA Registered",
        status: "New Launch"
      }
    },

    overview: {
      heading: "Shapoorji Pallonji The Dualis Sector 46, Gurgaon",
      description: [
        "Shapoorji Pallonji The Dualis is a luxury housing project in Sector 46, Gurgaon, built by a trusted developer, Shapoorji Pallonji. It offers comfortable and luxurious living in a great location.",
        "The project has 3BHK and 4BHK apartments of different sizes. These apartments are well-designed to have plenty of space, sunlight, and airflow. The interiors have high-quality finishes, including marble flooring in living areas, wooden flooring in bedrooms, and a fully-equipped kitchen. These features make everyday life stylish and easy.",
        "Shapoorji Pallonji Dualis is built on around 2 acres of land with two tall towers. Tower A has 33 floors and Tower B has 29 floors. It also has a grand entrance and lobby for residents and guests.",
        "The project includes many amenities for all ages, like a clubhouse with a swimming pool, yoga area, gym, spa, and play areas for kids. There are also quiet spaces, a library, and games like chess and table tennis.",
        "This project is approved by RERA, which ensures safety and transparency for buyers. It is developed by SPRE Gurugram Properties and Kandodia Hi-Tech Pvt. Ltd. (Kreeva)."
      ],
      keywordLinks: {
      },
      image: overviewImagedualis,
      buttonLabel: "Enquire Now",
      stripdata: [
        {
          iconClass: locationicondualis,
          title: "₹ 7 Crore Onwards",
          subtitle: "Starting Price",
        },
        {
          iconClass: calicondualis,
          title: "CLP",
          subtitle: "Payment Plan",
        },
        {
          iconClass: newlaunchicondualis,
          title: "New Launch",
          subtitle: "Status",
        },
      ],
    },

    pricing: {
      heading: "Pricing",
      table: [
        {
          type: "3 BHK",
          area: "2800 - 3000 sq.ft.",
          price: "On Request",
          eoiAmount: "Contact for Price",
        },
        {
          type: "4 BHK",
          area: "3400 - 3600 sq.ft.",
          price: "On Request",
          eoiAmount: "Contact for Price",
        },
      ],
    },

    floor_plan: [
      {
        type: "3 BHK",
        area: "2800 - 3000 sq.ft.",
        price: "On Request",
        image: floorplan1dualis,
      },
      {
        type: "4 BHK",
        area: "3400 - 3600 sq.ft.",
        price: "On Request",
        image: floorplan2dualis,
      }
    ],

    highlights: {
      images: Hightlightsdualis,
      tagline: "Highlights",
      features: [
        "The Sky Deck on the 45th floor has amazing city views and a calm atmosphere.",
        "It has great facilities like a pool, gym, clubhouse, and beautiful gardens.",
        "It is located in Sector 46, Gurgaon, with easy access to important places.",
        "The area covers 4.5 acres and has many towers with spacious, comfortable homes.",
        "Shapoorji Pallonji Dualis offers new homes with 3-bedroom and 4-bedroom options.",
        "RERA approved project ensuring safety and transparency for buyers.",
        "Premium finishes including marble and wooden flooring in living spaces."
      ],
    },

    location: {
      image: Locationdualis,
      data: [
        {
          airport: {
            distance_time: "15 km",
            name: "Indira Gandhi International (IGI) Airport"
          },
          school: {
            distance_time: "5 km",
            name: "Ryan International School"
          },
          railwayormetro: {
            distance_time: "51 km",
            name: "HUDA City Centre Metro Station"
          },
          hospital: {
            distance_time: "10 km",
            name: "Medanta – The Medicity"
          },
          mall: {
            distance_time: "4 km",
            name: "DLF CyberHub"
          }
        }
      ]
    },

    gallery: {
      color: "#cd8c66",
      tagline: "Project Gallery",
      images: [
        { image: gallery1dualis },
        { image: gallery2dualis },
        { image: gallery3dualis },
        { image: gallery4dualis },
        { image: gallery5dualis },
      ],
    },

    whatsapp: {
      title: "Property Station",
      subTitle: "Happy to Help You!",
      greetingText: "Hi there! \nHow can I help you?",
      ctaText: "Start Chat",
      whatsAppNumber: "7079429676",
      welcomeMessage:
        "Hi! I'm interested in Shapoorji Pallonji The Dualis, kindly share more details.",
    },

    faq: [
      {
        question: "What type of residences are available in The Dualis?",
        answer: "Shapoorji Pallonji The Dualis offers high-end residential apartments with spacious layouts",
      },
      {
        question: "Where is The Dualis by Shapoorji Pallonji located?",
        answer: "The project is situated in Sector 46, Gurgaon",
      },
      {
        question: "Who is the developer of The Dualis in Sector 46, Gurgaon?",
        answer: "The project is being developed by Shapoorji Pallonji Group",
      },
      {
        question: "What are the key amenities offered at Shapoorji Pallonji The Dualis?",
        answer: "The project offers a range of amenities such as a clubhouse, swimming pool, and gymnasium",
      },
      {
        question: "Is Shapoorji Pallonji The Dualis RERA approved?",
        answer: "Yes, the project is registered with the Real Estate Regulatory Authority (RERA)",
      },
      {
        question: "What is the connectivity like from The Dualis Sector 46 Gurgaon?",
        answer: "The project enjoys excellent connectivity to major roads and locations such as NH-48, Sohna Road",
      },
      {
        question: "Are there good schools and hospitals near The Dualis Gurgaon?",
        answer: "Yes, reputed schools like DPS, Amity, and hospitals like Medanta Medicity and Artemis Hospital",
      },
      {
        question: "Is The Dualis a good investment option in Gurgaon?",
        answer: "Yes, given its prime location, premium offerings, and the credibility of the Shapoorji Pallonji Group",
      },
      {
        question: "What size apartments are available in Shapoorji Pallonji The Dualis?",
        answer: "The project offers a variety of configurations such as 3 BHK, and 4 BHK with size range from 2800 - 3600 sq.ft.",
      },
      {
        question: "What are the tower configurations in The Dualis?",
        answer: "The project features two towers - Tower A with 33 floors and Tower B with 29 floors, spread across 2 acres of land.",
      }
    ],

    form_data: {
      api_userPublicKey: `hAXar+4nhMxu1UR9tnUpPoSTTyK37su4DQ2xzq57RjHuYj8kzLKu0Cy5N0wgQKA8`,
      api_userSecretKey: `jxbnqhp4n4hNsOm3pWW2+07pAlr7g3dP8ncMEArVTFtKX6q8V3mYqfA=`,
      source_id: 11,
      sub_source_id: 130,
      builder_id: `103`,
      project_id: `477`,
      subject: "Property Station enquiry - Shapoorji Pallonji The Dualis",
      to_email: "leads@gurugram-property.com",
    },
  },
}